export default "__VITE_ASSET__iy6s5IVc__"